import React, { FC } from 'react';
import { Chip, ChipsList } from '@clds/chip';
import { CookbookTransformation } from '../../types';
import { ComplexityTag } from '../ComplexityTag/ComplexityTag';
import { SearchOption } from '../SearchField';
import { PillsLayout } from './CookbookTransformationCard.styled';

export interface PillsProps {
  tags: CookbookTransformation['categories'];
  complexity: CookbookTransformation['complexity'];
  onQueryChipClick: (option: SearchOption) => void;
  isMobile: boolean;
}

export const Pills: FC<React.PropsWithChildren<PillsProps>> = ({ tags, complexity, isMobile, onQueryChipClick }) => {
  const setQueryCallback = () => onQueryChipClick({ complexity });

  return (
    <PillsLayout distanced={isMobile}>
      <ChipsList>
        {tags.map(({ name: category }) => (
          <Chip
            data-testid="tag-chip"
            onClick={() => {
              onQueryChipClick({ category });
            }}
            key={category}
            label={category}
            isHoverable
          />
        ))}
        <ComplexityTag data-testid="complexity-chip" onClick={setQueryCallback} complexity={complexity} isHoverable />
      </ChipsList>
    </PillsLayout>
  );
};
